<template>

  <div>
    <div class="form-group">
      <input
        type="text"
        class="form-control"
        :placeholder="$t('Question')"
        :value="value.label"
        @input="inputLabel">
      <ValidateMessage
        :error="validateErrors['application_questions.' + questionIndex + '.label']" />
    </div>
    <div class="form-group">
      <select
        type="text"
        class="form-control"
        :value="value.type"
        @change="changeType">
        <option value="text">{{ $t('Short text') }}</option>
        <option value="textarea">{{ $t('Long text') }}</option>
        <option value="radio">{{ $t('List of options (Single choice)') }}</option>
        <option value="checkbox">{{ $t('List of options (Multiple choice)') }}</option>
        <option value="boolean">{{ $t('Yes or no') }}</option>
      </select>
      <ValidateMessage :error="validateErrors['application_questions.' + questionIndex + '.type']" />
    </div>

    <div v-if="value.type === 'boolean'">
      <ul class="form-items">
        <li>
          <div class="form-items-input">
            <input 
              type="text"
              :value="$t('Yes')"
              disabled>
          </div>
          <div>
            <div class="form-check">
              <input
                class="form-check-input"
                type="checkbox"
                :checked="value.disqualifyOn === 'yes'"
                :disabled="value.disqualifyOn === 'no'"
                @change="changeDisqualifierValue($event.target.checked ? 'yes' : null)">
              <label
                class="form-check-label">{{ $t('Disqualifier') }}</label>
            </div>
          </div>
        </li>
        <li>
          <div class="form-items-input">
            <input 
              type="text"
              :value="$t('No')"
              disabled>
          </div>
          <div>
            <div class="form-check">
              <input
                class="form-check-input"
                type="checkbox"
                :checked="value.disqualifyOn === 'no'"
                :disabled="value.disqualifyOn === 'yes'"
                @change="changeDisqualifierValue($event.target.checked ? 'no' : null)">
              <label
                class="form-check-label">{{ $t('Disqualifier') }}</label>
            </div>
          </div>
        </li>
      </ul>
      <ValidateMessage :error="validateErrors['application_questions.' + questionIndex + '.disqualify']" />
    </div>

    <div v-if="value.type === 'radio' || value.type === 'checkbox'">
      <ul
        class="form-items"
        v-sortable="{ handle: '.move', items: value.options}">
        <li
          v-for="(option, optionIndex) in value.options">
          <div>
            <a
              ref="javascript:void(0)"
              class="move text-secondary">
              <i class="fas fa-arrows-alt" />
            </a>
          </div>
          <div class="form-items-input">
            <input 
              type="text" 
              :placeholder="$t('Alternative')"
              :value="value.options[optionIndex].label"
              @input="inputOptionLabel(optionIndex, $event)">
            <ValidateMessage
              :error="validateErrors['application_questions.' + questionIndex + '.options.' + optionIndex]" />
          </div>
          <div>
            <div class="form-check">
              <input
                class="form-check-input"
                type="checkbox"
                :id="'isDisqualifier' + optionIndex"
                :disabled="value.options.filter(option => !option.isDisqualifier).length <= 1 && !value.options[optionIndex].isDisqualifier"
                v-model="value.options[optionIndex].isDisqualifier">
              <label
                class="form-check-label"
                :for="'isDisqualifier' + optionIndex">{{ $t('Disqualifier') }}</label>
            </div>
            <ValidateMessage
              :error="validateErrors['application_questions.' + questionIndex + '.options.' + optionIndex + '.isDisqualifier']" />
          </div>
          <div>
            <a
              href="javascript:void(0)"
              @click="removeOption(optionIndex)"
              class="text-secondary">
              <i class="fas fa-times" />
            </a>
          </div>
        </li>
      </ul>
      <ValidateMessage
        :error="validateErrors['application_questions.' + questionIndex + '.options']" />
      <br>
      <a
        href="javascript:void(0)"
        @click="addOption">Adicionar opção</a>
    </div>
  </div>

</template>

<script>
export default {
  name: 'TemplateapplyForm',
  components: {},
  props: {
    questionIndex: {
      type: [Number, String],
      required: true
    },
    value: {
      type: Object,
      default: () => ({})
    },
    validateErrors: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
    }
  },
  computed: {
  },
  created () {
  },
  methods: {
    inputLabel (event) {
      this.$emit('input', { ...this.value, label: event.target.value })
    },
    changeType (event) {
      const type = event.target.value
      this.$emit('input', { ...this.value, type })
    },
    inputOptionLabel (optionIndex, event) {
      const options = [...this.value.options]
      if (options[optionIndex]) {
        options[optionIndex].label = event.target.value
        this.$emit('input', { ...this.value, options })
      }
    },
    changeDisqualifierValue (value) {
      this.$emit('input', { ...this.value, disqualifyOn: value })
    },
    addOption () {
      const options = [...this.value.options, { label: '', isDisqualifier: false }]
      this.$emit('input', { ...this.value, options })
    },
    removeOption (optionIndex) {
      const options = [...this.value.options]
      options.splice(optionIndex, 1)
      this.$emit('input', { ...this.value, options })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Templateapply/TemplateapplyFormQuestionsItem.vue